import { memo } from "react"

const NoData = () => (
  <div className="relative flex-1 py-24">
    <div className="w-full flex items-center justify-center text-center">
      No data yet, try another range.
    </div>
  </div>
)

export default memo(NoData)
